// SRL Wrapper
import { SRLWrapper } from 'simple-react-lightbox'

// Interfaces
import { IBaseImagePreviewProps } from './interfaces'

const BaseImagePreview = ({ children, ...props }: IBaseImagePreviewProps) => {
  return (
    <SRLWrapper
      options={{
        ...props,
        settings: {
          downloadedFileName: 'lsp-asset',
          disableKeyboardControls: true,
          disableWheelControls: true,
          disablePanzoom: true,
          ...props.settings,
        },
        buttons: {
          showAutoplayButton: false,
          showFullscreenButton: false,
          showThumbnailsButton: false,
          showNextButton: false,
          showPrevButton: false,
          showDownloadButton: false,
          ...props.buttons,
        },
        caption: { showCaption: false, ...props.caption },
        thumbnails: { showThumbnails: false, ...props.thumbnails },
      }}
    >
      {children}
    </SRLWrapper>
  )
}

export { BaseImagePreview }
